// toast-container.component.ts
import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastContainerService } from './toast-container.service';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [CommonModule],
  templateUrl: '../toast-container/toast-container.component.html',
  styleUrl: '../toast-container/toast-container.component.css',
})
export class ToastContainerComponent {
  toastService = inject(ToastContainerService);
}